export default __webpack_public_path__ + "static/media/CreateSpecCenterImage.44da67e2.svg";